export default __webpack_public_path__ + "static/media/whatsapp.af24d646.svg";